import { lazy } from 'react';

export const LazyDocumentationTopic = lazy(() => import('@/pages/DocumentationTopic'));